import { render, staticRenderFns } from "./Entrance.vue?vue&type=template&id=71911ea2&lang=pug"
import script from "./Entrance.vue?vue&type=script&lang=js"
export * from "./Entrance.vue?vue&type=script&lang=js"
import style0 from "./Entrance.vue?vue&type=style&index=0&id=71911ea2&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports